"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabsAlertMessage = void 0;
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
require("./index.scss");
const string_to_inline_1 = require("@App/helpers/string-to-inline");
const contexts_1 = require("@App/contexts");
exports.TabsAlertMessage = (0, mobx_react_1.observer)((props) => {
    const { popupStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const tabsAlertData = popupStore.tabsAlertData;
    const itIsCurrentTab = tabsAlertData && (0, string_to_inline_1.stringToInline)(tabsAlertData.tabName) === (0, string_to_inline_1.stringToInline)(props.currentTab);
    if (!tabsAlertData || !tabsAlertData.message || !itIsCurrentTab) {
        return null;
    }
    return (react_1.default.createElement("div", { className: `tabs-alert-message-component ${tabsAlertData.isError ? 'error' : ''}` },
        react_1.default.createElement("p", null, tabsAlertData.message)));
});
